import { Box, Typography } from '@mui/material';

import { FHConfirmDialog } from '../../../../../../../components/base';
import { FORTA_GRAY5 } from '../../../../../../../utils/colors';

import type { NoSecondaryInsuranceConfirmModalProps } from './types';

export default function NoSecondaryInsuranceConfirmModal({
  open,
  submitLoading,
  onClose,
  onSubmit,
}: NoSecondaryInsuranceConfirmModalProps) {
  return (
    <FHConfirmDialog
      open={open}
      title="Remove secondary insurance?"
      submittext="Remove"
      canceltext="Cancel"
      submitLoading={submitLoading}
      onClose={onClose}
      onSubmit={onSubmit}
      dialogHeight="auto"
      footerContainerStyles={{ mt: 4 }}
      contentRenderer={() => (
        <Box sx={{ pt: 1 }}>
          <Typography sx={{ color: FORTA_GRAY5, fontSize: 14 }}>
            Marking this client as having no secondary insurance will permanently delete the
            secondary insurance details and uploaded card images. This can’t be undone.
          </Typography>
        </Box>
      )}
    />
  );
}
